const normalizeText = (value: any) => String(value || "").trim();

export const PRN_REASON_OPTIONS = [
  { label: "Pain", value: "pain" },
  { label: "Headache", value: "headache" },
  { label: "Anxiety", value: "anxiety" },
  { label: "Agitation", value: "agitation" },
  { label: "Insomnia", value: "insomnia" },
  { label: "Constipation", value: "constipation" },
  { label: "Nausea", value: "nausea" },
  { label: "Shortness of breath", value: "shortness_of_breath" },
  { label: "Fever", value: "fever" },
  { label: "Other", value: "other" },
];

export const PRN_EFFECTIVENESS_OPTIONS = [
  { label: "Improved", value: "improved" },
  { label: "Partially improved", value: "partially_improved" },
  { label: "No change", value: "no_change" },
  { label: "Worsened", value: "worsened" },
  { label: "Unable to reassess", value: "unable_to_reassess" },
];

export const PRN_SIDE_EFFECT_OPTIONS = [
  { label: "None observed", value: "none_observed" },
  { label: "Drowsiness", value: "drowsiness" },
  { label: "Dizziness", value: "dizziness" },
  { label: "Nausea", value: "nausea" },
  { label: "Stomach upset", value: "stomach_upset" },
  { label: "Rash", value: "rash" },
  { label: "Other", value: "other" },
];

const getLabel = (options: ReadonlyArray<{ label: string; value: string }>, value: any) => {
  const normalized = normalizeText(value);
  return options.find((item) => item.value === normalized)?.label || normalized;
};

export const getPrnReasonLabel = (entry: any) => normalizeText(entry?.prnReasonLabel) || getLabel(PRN_REASON_OPTIONS, entry?.prnReasonCode);
export const getPrnEffectivenessLabel = (entry: any) => normalizeText(entry?.prnEffectivenessLabel) || getLabel(PRN_EFFECTIVENESS_OPTIONS, entry?.prnEffectiveness);
export const getPrnSideEffectLabel = (entry: any) => normalizeText(entry?.prnSideEffectLabel) || getLabel(PRN_SIDE_EFFECT_OPTIONS, entry?.prnSideEffectCode);

export const buildPrnDetailRows = (entry: any) => {
  const rows: Array<{ label: string; value: string }> = [];
  const reasonLabel = getPrnReasonLabel(entry);
  const reassessedAt = normalizeText(entry?.prnReassessedAt);
  const effectivenessLabel = getPrnEffectivenessLabel(entry);
  const sideEffectLabel = getPrnSideEffectLabel(entry);
  const sideEffectNote = normalizeText(entry?.prnSideEffectNote);
  const followUpNote = normalizeText(entry?.prnFollowUpNote);

  if (reasonLabel) {
    rows.push({ label: "Reason", value: reasonLabel });
  }
  if (reassessedAt) {
    rows.push({ label: "Reassessed", value: reassessedAt });
  }
  if (effectivenessLabel) {
    rows.push({ label: "Effectiveness", value: effectivenessLabel });
  }
  if (sideEffectLabel) {
    rows.push({ label: "Side effects", value: sideEffectLabel });
  }
  if (sideEffectNote) {
    rows.push({ label: "Side effect note", value: sideEffectNote });
  }
  if (followUpNote) {
    rows.push({ label: "Follow-up note", value: followUpNote });
  }

  return rows;
};
